import { render, staticRenderFns } from "./SafetyObservationCategoryNewForm.vue?vue&type=template&id=717446ff"
import script from "./SafetyObservationCategoryNewForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationCategoryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports